import { StorageProcessState } from '../hooks/useStorage';

/**
 * Uploads an in-app logo (the coach's or a product's) to storage and returns its reference.
 *
 * @param {string} iconUrl - The picked file's object URL.
 * @param {Function} upload - `useStorage().uploadAttachment`.
 * @param {File} image - The picked file.
 * @param {string} storagePath - The folder to upload into, already formatted.
 * @return {Promise<string>} The uploaded file's storage reference.
 */
const uploadAppIcon = async (iconUrl, upload, image, storagePath) => {
  const extensionIndex = image.name.lastIndexOf('.');
  const imageFormat = image.name.slice(extensionIndex + 1);
  const fileName = image.name.slice(0, extensionIndex);
  const fileType = image.type;

  const { state, fileRef } = await upload(iconUrl, imageFormat, storagePath, fileName, fileType);

  if (state === StorageProcessState.FAILED) {
    throw new Error('There was an error in uploading the icon to storage');
  }

  return fileRef;
};

export {
  uploadAppIcon,
};
